
export default (props, inject) => {
  const popUpNotification = function (params = {}) {
    props.store.commit("pop-up-notification/openPopUp", params);
  }

  inject('popUpNotification', popUpNotification)
}
